import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useScheduleExportDialog } from './hooks';
import { DateRangeForm, DialogActionButtons, HiddenExportGrid } from './components';

interface ScheduleExportDialogContentProps {
  open: boolean;
  onClose: () => void;
}

export const ScheduleExportDialogContent: React.FC<ScheduleExportDialogContentProps> = ({
  open,
  onClose,
}) => {
  const {
    company,
    center,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    isLoading,
    isExporting,
    error,
    canExport,
    transformedData,
    gridRef,
    handleExport,
    handleClose,
  } = useScheduleExportDialog(onClose);

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Export Schedule</Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <DateRangeForm
            startDate={startDate}
            endDate={endDate}
            company={company}
            center={center}
            error={error}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
          />
        </DialogContent>

        <DialogActions>
          <DialogActionButtons
            canExport={!!canExport}
            isLoading={isLoading}
            isExporting={isExporting}
            onCancel={handleClose}
            onExport={handleExport}
          />
        </DialogActions>
      </Dialog>

      <HiddenExportGrid
        transformedData={transformedData}
        gridRef={gridRef}
      />
    </>
  );
};

export default ScheduleExportDialogContent;
